import {
  INavbarItem,
  INavbarItemGenieAsk,
} from '@models/interfaces/navigation.interface';
import { DropdownNavigationItem } from '@components/navigation/DropdownAccountNavigation';
import {
  FEATURE_BADGES,
  MENU_PAGE_ACCOUNT,
  MENU_PAGE_GENIEASK,
  MENU_PAGE_GENIECLASS,
  MENU_PAGE_GENIESMART,
  MENU_PAGE_LEADERBOARD,
  MENU_PAGE_PROGRESS,
} from '@utils/constants/menu.constants';
import { CDN_URL } from '@utils/constants/url.constants';

type NavbarListProps = {
  showGenieAskInBottomNavbar?: boolean;
};

export const NavbarList = ({
  showGenieAskInBottomNavbar,
}: NavbarListProps): (INavbarItem | INavbarItemGenieAsk)[] => [
  {
    key: 'geniesmart',
    label: 'Worksheets',
    url: 'worksheets',
    icon: `${CDN_URL}assets/icons/navigation/geniesmart.svg`,
    activeIcon: `${CDN_URL}assets/icons/navigation/geniesmart-active.svg`,
    selected: false,
    showInBottomNavbar: true,
    showInTopNavbar: true,
    relateToSubject: true,
    menuId: MENU_PAGE_GENIESMART,
    path: '/:subject_id/worksheets',
  },
  {
    key: 'genieclass',
    label: 'Classes',
    url: 'classes',
    icon: `${CDN_URL}assets/icons/navigation/genieclass.svg`,
    activeIcon: `${CDN_URL}assets/icons/navigation/genieclass-active.svg`,
    selected: false,
    showInBottomNavbar: true,
    showInTopNavbar: true,
    relateToSubject: true,
    menuId: MENU_PAGE_GENIECLASS,
    path: '/:subject_id/classes',
  },
  {
    key: 'progress',
    label: 'Progress',
    url: 'progress',
    icon: `${CDN_URL}assets/icons/navigation/progress.svg`,
    activeIcon: `${CDN_URL}assets/icons/navigation/progress-active.svg`,
    selected: false,
    showInBottomNavbar: true,
    showInTopNavbar: true,
    relateToSubject: true,
    menuId: MENU_PAGE_PROGRESS,
    path: '/:subject_id/progress',
  },
  {
    key: 'genieask',
    label: 'Chat',
    url: 'genieask',
    icon: `${CDN_URL}assets/icons/navigation/genieask.svg`,
    activeIcon: `${CDN_URL}assets/icons/navigation/genieask-active.svg`,
    selected: false,
    showInBottomNavbar: showGenieAskInBottomNavbar,
    showInTopNavbar: false,
    relateToSubject: false,
    menuId: MENU_PAGE_GENIEASK,
    unreadIcon: `${CDN_URL}assets/icons/navigation/genieask-unread.svg`,
    unreadActiveIcon: `${CDN_URL}assets/icons/navigation/genieask-active-unread.svg`,
    path: '/genieask',
  } as INavbarItemGenieAsk,
  {
    key: 'account',
    label: 'Account',
    url: 'account',
    icon: `${CDN_URL}assets/icons/navigation/account.svg`,
    activeIcon: `${CDN_URL}assets/icons/navigation/account-active.svg`,
    selected: false,
    showInBottomNavbar: true,
    showInTopNavbar: false,
    relateToSubject: false,
    menuId: MENU_PAGE_ACCOUNT,
    path: '',
  },
  {
    key: 'leaderboard',
    label: 'Leaderboard',
    url: 'leaderboard',
    icon: '',
    activeIcon: '',
    selected: false,
    showInBottomNavbar: false,
    showInTopNavbar: false,
    relateToSubject: false,
    menuId: MENU_PAGE_LEADERBOARD,
    path: '',
  },
];

export const AccountDropdown: DropdownNavigationItem[] = [
  {
    key: 'profile',
    label: 'Profile',
    url: '/profile',
  },
  {
    key: 'badges',
    label: 'Badges',
    url: '/badges',
    featureId: FEATURE_BADGES,
  },
  {
    key: 'achievements',
    label: 'Achievements',
    url: '/leaderboard',
    domId: 'leaderboard-navigation',
  },
  {
    key: 'settings',
    label: 'Settings',
    url: '/account-settings',
  },
  {
    key: 'help',
    label: 'Help Centre',
    url: 'https://geniebook.atlassian.net/servicedesk/customer/portal/1',
  },
  {
    key: 'logout',
    label: 'Logout',
    url: '',
  },
];
